<template>
  <div
    :key="src"
    @click="handleClick"
    class="video-player"
    :class="{ 'video-player--preview': preview }"
  >
    <video class="video" ref="video" :style="{'max-width': maxWidth, 'min-width': minWidth,'max-height': maxHeight, 'min-height': minHeight}" :controls="!preview" :preview="preview">
      <source :src="src" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    src: String,
    preview: Boolean,
    maxWidth: [String, Number],
    minWidth: [String, Number],
    maxHeight: [String, Number],
    minHeight: [String, Number],
  },
  computed: {
    videoElement() {
      return this.$refs && this.$refs.video
    },
  },
  methods: {
    handleClick(v) {
      this.$emit('click', v)
    },
  },
}
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
  position: relative;
  max-height: inherit;
  video {
    cursor: pointer;
    width: 100%;
    max-height: inherit;
  }
  &--preview {
    &::before {
      width: 50px;
      height: 50px;
      position: absolute;
      color: white;
      background: #333333;
      content: '\25B6';
      opacity: 0.5;
      position: absolute;
      // text-shadow: 0 3px black;
      // z-index: 100;
      font-size: 25px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }
    &:hover {
      &::before {
        background: #111111;
      }
    }
  }
}
</style>
